import React, { useState, useEffect } from 'react';
import { Typography } from '@mui/material';
import { MapContainer as Map, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';

// ponytail: swapped google-maps-react → react-leaflet (no API key, no billing).
const iconConnected = new L.Icon({
  iconUrl: new URL('../../assets/images/connected.png', import.meta.url).href,
  iconSize: [32, 32],
  iconAnchor: [16, 32],
});
const iconDisconnected = new L.Icon({
  iconUrl: new URL('../../assets/images/disconnected.png', import.meta.url).href,
  iconSize: [32, 32],
  iconAnchor: [16, 32],
});

const MapArea = (props) => {
  const [selectedAp, setSelectedAp] = useState(null);

  useEffect(() => {
    setSelectedAp(null);
  }, [props.apData]);

  return (
    <Map
      center={[39.8097343, -98.5556199]}
      zoom={4}
      scrollWheelZoom={false}
      doubleClickZoom={false}
      style={{ height: '98%', width: '95%', margin: '0 auto' }}
    >
      <TileLayer
        attribution='&copy; OpenStreetMap contributors'
        url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
      />
      {(props.apData || []).map((ap, index) => (
        <Marker
          key={index}
          position={[ap.lat, ap.lng]}
          icon={ap.status ? iconConnected : iconDisconnected}
          onClick={() => setSelectedAp(ap)}
        >
          {selectedAp && selectedAp.oro_id === ap.oro_id && (
            <Popup onClose={() => setSelectedAp(null)}>
              <div>
                <Typography component='h6' variant='h6'>
                  {((ap || {}).company || {}).business_name || '---'}
                </Typography>
                <Typography variant='subtitle1' color='textSecondary'>
                  {(ap || {}).serial_number || '---'}
                </Typography>
                <Typography variant='subtitle1' color='textSecondary'>
                  Channels : {ap.channels}
                </Typography>
              </div>
            </Popup>
          )}
        </Marker>
      ))}
    </Map>
  );
};

export default MapArea;
